<div
  class="email-png-preview-dialog flex h-full flex-col overflow-hidden"
  (click)="onBackgroundClick($event)">
  <header class="flex items-center justify-between gap-4 px-6 py-3">
    <div class="flex min-w-0 items-center gap-3">
      @if (store.current(); as _current) {
        <h2
          class="truncate text-base font-medium text-white"
          [title]="_current.filename || _current.name">
          {{ _current.filename || _current.name | truncateFilename: 60 }}
        </h2>
      } @else {
        <h2 class="text-base font-medium text-white">Preview file</h2>
      }
      @if (store.canNavigate()) {
        <span class="whitespace-nowrap text-xs text-gray-4">
          {{ store.currentIndex() + 1 }} of {{ store.pdfs.length }}
        </span>
      }
    </div>
    <button
      class="flex size-9 items-center justify-center rounded-full text-white hover:bg-white/10"
      type="button"
      title="Close"
      (click)="close()">
      <span class="material-symbols-outlined text-xl leading-none">close</span>
    </button>
  </header>

  <div class="relative min-h-0 flex-1 px-16 pb-4">
    @if (store.pngFiles().length) {
      <oiq-image-preview-zoom
        [attachments]="store.pngFiles()"
        [enableZoom]="false"
        class="block h-full">
      </oiq-image-preview-zoom>
    } @else if (store.isLoading()) {
      <div class="flex h-full items-center justify-center gap-3 text-white">
        <span class="ph ph-spinner animate-spin text-2xl text-primary"></span>
        <p>Loading preview...</p>
      </div>
    } @else if (store.error()) {
      <div class="flex h-full flex-col items-center justify-center gap-3 text-white">
        <div class="flex items-center gap-2">
          <span class="ph ph-warning text-2xl text-primary"></span>
          <span>{{ store.error() }}</span>
        </div>
        <button class="oiq-button oiq-button--outline" type="button" (click)="store.retry()">
          Try again
        </button>
      </div>
    }

    @if (store.canNavigate()) {
      <button
        class="absolute left-3 top-1/2 flex size-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70 disabled:cursor-not-allowed disabled:opacity-30"
        type="button"
        title="Previous file"
        [disabled]="!store.hasPrevious()"
        (click)="store.previous()">
        <span class="ph ph-caret-left text-lg"></span>
      </button>
      <button
        class="absolute right-3 top-1/2 flex size-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70 disabled:cursor-not-allowed disabled:opacity-30"
        type="button"
        title="Next file"
        [disabled]="!store.hasNext()"
        (click)="store.next()">
        <span class="ph ph-caret-right text-lg"></span>
      </button>
    }
  </div>
</div>
